import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal, Select } from 'antd'
import Loader from '../../pages/pages/loader'

import {
  useCreateM3uKeywordMutation,
  useUpdateM3uKeywordMutation
} from '../../redux/apis/linkManagement/m3u/lmM3uKeywordsApiSlice'
import CustomersDropdown from '../CustomersDropdown'

const EditCreateM3uKeyword = ({ state, open, setOpen, record }) => {
  const [
    update,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateM3uKeywordMutation()
  const [
    create,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateM3uKeywordMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      m3u_keyword:record?.m3u_keyword,
      keyword_status:state === "edit"?record?.keyword_status? true:false:true,
      customer:record?.customer?.id,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      customer: Yup.number().required('Please Select Customer'),
      keyword_status: Yup.boolean().required('Please Select Keyword status'),
      m3u_keyword: Yup.string().required('Please Enter m3u Keyword '),
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await update({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await create(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('M3U Keyword created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('M3U Keyword successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit M3U Keyword` : 'Create M3U Keyword'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />
      <div className=' mb-3'>
        <CustomersDropdown
          onChange={e => {
            validation.setFieldValue('customer', e)
          }}
          value={validation.values.customer}
          onBlur={validation.handleBlur}
        />
        {validation.touched.customer && validation.errors.customer ? (
          <p className='text-danger'>{validation.errors.customer}</p>
        ) : null}
      </div>
      <div className=' mb-3'>
        <label className="form-label">M3U Keyword</label>
        <Input
          type='text'
          name='m3u_keyword'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.m3u_keyword}
        />
        {validation.touched.m3u_keyword && validation.errors.m3u_keyword ? (
          <p className='text-danger'>{validation.errors.m3u_keyword}</p>
        ) : null}
      </div>
      <div className=' mb-3 flex-1'>
        <label>Keyword Status</label>
        <br />
        <Select
          className={''}
          name='keyword_status'
          style={{
            width: '100%'
          }}
          defaultValue={validation?.values?.keyword_status}
          value={validation?.values?.keyword_status}
          onChange={e => validation.setFieldValue('keyword_status', e)}
          onBlur={validation.handleBlur}
          options={[
            {
              label: 'Active',
              value: true
            },
            {
              label: 'Inactive',
              value: false
            }
          ]}
        />
        {validation.touched.keyword_status && validation.errors.keyword_status ? (
          <p className='text-danger'>{validation.errors.keyword_status}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateM3uKeyword
